import React from 'react';
import './ForestClearanceCompliance.css'; // Add a CSS file for specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import backgroundimg from '../../assets/images/forest-clearance-1.jpg';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_forest_banner from '../../assets/images/img_peso1_banner.png'; // Replace with an appropriate image path
import { FaTree, FaRegFileAlt, FaHandsHelping, FaSearchLocation, FaFileSignature, FaComments, FaPaperPlane, FaCheckCircle } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function ForestClearanceCompliance() {
  const benefits = [
    {
      icon: <FaTree />,
      title: 'Environmental Conservation',
      text: 'Ensure sustainable development while protecting forest resources.',
    },
    {
      icon: <FaRegFileAlt />,
      title: 'Regulatory Adherence',
      text: 'Comply with forest clearance laws to avoid delays and legal issues.',
    },
    {
      icon: <FaHandsHelping />,
      title: 'Stakeholder Trust',
      text: 'Build trust with stakeholders by adhering to government regulations.',
    },
    {
      icon: <FaSearchLocation />,
      title: 'Streamlined Process',
      text: 'Navigate the complex approval process efficiently with expert guidance.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Consultation',
      description: 'Understand project requirements and evaluate the need for forest clearance.',
    },
    {
      icon: <FaFileSignature />,
      title: 'Application Preparation',
      description: 'Prepare and compile the necessary documents for submission.',
    },
    {
      icon: <FaSearchLocation />,
      title: 'Site Inspection',
      description: 'Assist in conducting inspections and assessments of the project site.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Submission and Follow-up',
      description: 'Submit the forest clearance application and coordinate with authorities for approvals.',
    },
    {
      icon: <FaCheckCircle />,
      title: 'Final Approval',
      description: 'Obtain the necessary clearance certificates for your project.',
    },
  ];

  const acts = [
    'Forest (Conservation) Act, 1980',
    'Wildlife Protection Act, 1972',
    'Indian Forest Act, 1927',
    'Environment Protection Act, 1986',
  ];

  const explanation =
    'Forest Clearance Compliance ensures that development projects adhere to environmental guidelines while safeguarding forest resources. It balances ecological conservation and economic growth, ensuring sustainability and legal compliance for your projects.';

  const checklistItems = [
    { name: 'Project Proposal', description: 'Detailed proposal including the project location and objectives.' },
    { name: 'Forest Area Map', description: 'Map showing the location and extent of forest area involved.' },
    { name: 'Environmental Impact Assessment', description: 'EIA report highlighting the potential impact of the project.' },
    { name: 'Compensatory Afforestation Plan', description: 'Plan outlining afforestation measures as per regulations.' },
    { name: 'Nodal Officer Consent', description: 'Consent from the designated Forest Department officer.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Forest Clearance Compliance Services"
        subheading="Simplify the process of obtaining forest clearances while ensuring compliance with environmental laws."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/forest-clearance-compliance' }}
        backgroundImage={backgroundimg} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Forest Clearance Compliance?"
        description="Forest Clearance Compliance is crucial for projects that impact forest lands. We guide you through the regulatory process to secure necessary approvals while ensuring sustainability and legal adherence."
        image={img_forest_banner} // Replace with a relevant image
        altText="Forest Clearance Compliance"
      />

      <ServicesBenefitsSection
        title="Why Forest Clearance Compliance Matters?"
        description="Learn why adhering to forest clearance regulations is vital for your project and the environment."
        benefits={benefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Legal Frameworks for Forest Clearance Compliance"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Forest Clearance Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Forest Clearance Compliance Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
